module.exports = __webpack_public_path__ + "media/Video 12b.d17bb3fa.mp4";